import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import MusicPlayer from './../player/MusicPlayer';
import NavBar from '../navigation/NavBar';
import SideBar from '../navigation/SideBar';
import Container from '../views/Container';
import navigationStore from '../../stores/navigation';
import SongbookSideBar from '../navigation/SongbookSideBar';
import SongbookContainer from '../views/SongbookContainer';
import SongbookNavBar from '../navigation/SongbookNavBar';

function SongbookLandscape() {
  const isSideBarOn = navigationStore((state) => state.isSideBarOn);
  const drawerWidth = isSideBarOn ? 250 : 0;

  const videoJsOptions = {
    autoplay: false,
    controls: false,
    responsive: false,
    poster:null,
    fluid: false,
    width: "100%",
    height: "100%",
    sources: [{
      type: 'application/x-mpegURL'
    }]
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <SongbookNavBar
        drawerWidth={drawerWidth}
      >
      </SongbookNavBar>
      {isSideBarOn &&
        (
          <SongbookSideBar drawerWidth={drawerWidth} />
        )
      }
      <Box
        component="main"
        sx={{ flexGrow: 1, bgcolor: 'background.default', p: 0, marginLeft:0 }}
      >
        <SongbookContainer />
      </Box>
    </Box>
  );
}

export default SongbookLandscape;
